import { z } from 'zod';

/**
 * Payment Domain Value Objects
 * Payment-specific domain value objects and enums
 */

// === Payment Method Enums ===

export const PaymentCaptureMethodSchema = z.enum(['automatic', 'manual'], {
  error: "Invalid payment capture method. Must be one of: automatic, manual"
});

export const PaymentConfirmationMethodSchema = z.enum(['automatic', 'manual'], {
  error: "Invalid payment confirmation method. Must be one of: automatic, manual"
});

export const PaymentActionTypeSchema = z.enum(['3d_secure', 'redirect'], {
  error: "Invalid payment action type. Must be one of: 3d_secure, redirect"
});

// Export TypeScript types
export type PaymentCaptureMethod = z.infer<typeof PaymentCaptureMethodSchema>;
export type PaymentConfirmationMethod = z.infer<typeof PaymentConfirmationMethodSchema>;
export type PaymentActionType = z.infer<typeof PaymentActionTypeSchema>;